import { useEffect, useState } from 'react';
import './HomePage.css';
import ReasonNav from '../components/reason/ReasonNav';
import ReasonFooter from '../components/reason/ReasonFooter';
import { Link } from '../components/Link';
import headerBgWEBP from '../images/home/header-bg.webp';
import headerTitleWEBP from '../images/home/header-title.webp';
import videoSectionBgWEBP from '../images/home/video-section-bg.webp';
import videoWrapperWEBP from '../images/home/video-wrapper.webp';
import playDownloadSVG from '../images/home/play-download.svg';
import discordIconSVG from '../images/home/discord-icon.svg';
import ctaTitleWEBP from '../images/home/cta-title.webp';
import browseArrowSVG from '../images/home/browse-arrow-right.svg';
import calendarIconSVG from '../images/articles/calendar-icon.svg';
import dividerPNG from '../images/store/divider.png';
import reel1PNG from '../images/reel/reel-1.png';
import reel2PNG from '../images/reel/reel-2.png';
import reel3PNG from '../images/reel/reel-3.png';
import reel4PNG from '../images/reel/reel-4.png';
import reel5PNG from '../images/reel/reel-5.png';
import { SITE_DISCORD } from '../data/siteContact';

export { Link } from '../components/Link';

const YOUTUBE_EMBED = 'https://www.youtube.com/embed/W-MH4a0kNmM?si=qYIe4Y6pvPVkP1Yl';

const CAROUSEL_IMAGES = [reel1PNG, reel2PNG, reel3PNG, reel4PNG, reel5PNG];

const LATEST_NEWS = [
  {
    date: 'July 31, 2025',
    title: 'July 2025 - Final Update of the Month!',
    description: 'Merlins Max cape, Araxxor slayer helmet, and Sunlight spear',
  },
  {
    date: 'July 29, 2025',
    title: 'July 2025 - Summer Event is LIVE!',
    description: 'Enjoy the summer event with tons of cool rewards and things to do <3',
  },
  {
    date: 'July 25, 2025',
    title: 'July 2025 Updates - DoE, Balance Elemental, and more!',
    description: 'With this release of Raids 4, it brings tons of new events and content',
  },
];

function HomePage() {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const root = document.getElementById('root');
    const prevRootBg = root?.style.backgroundColor;
    if (root) root.style.backgroundColor = '#111013';
    return () => {
      document.body.style.overflow = '';
      if (root) root.style.backgroundColor = prevRootBg || '';
    };
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
  }, [menuOpen]);

  return (
    <div className={`reason-page home-page${menuOpen ? ' menu-open' : ''}`}>
      <ReasonNav activePage="home" menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

      <section className="hero-container">
        <img src={headerBgWEBP} alt="background image." className="header-bg-style" />
        <div className="container home-page-content" style={{ position: 'relative', zIndex: 2 }}>
          <img
            src={headerTitleWEBP}
            alt="A brand new adventure image"
            className="w-75 mx-auto brand-new"
          />
          <p className="hero-tagline">
            Designed by passionate veterans, Treason reinvents the grind with unique features
            <br />
            and boundless fun. Experience the game you love, reimagined!
          </p>
          <div className="cta-section">
            <div className="cta-grid">
              <div className="cta-item">
                <Link to="/play" className="button primary large">
                  <img src={playDownloadSVG} alt="play now" className="icon" />
                  Play Now
                </Link>
              </div>
              <div className="cta-item">
                <a href={SITE_DISCORD} className="button secondary large" target="_blank" rel="noreferrer">
                  <img src={discordIconSVG} alt="discord" className="icon" />
                  Join Discord
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="hero-container" style={{ position: 'relative' }}>
        <img src={videoSectionBgWEBP} alt="video section background image." className="bg-hero-section" />
        <div className="container" style={{ position: 'relative', zIndex: 2 }}>
          <h3 className="video-section-title">WELCOME TO TREASONPS</h3>
          <div className="video-container">
            <img src={videoWrapperWEBP} alt="video-wrapper" className="video-wrapper" />
            <div className="video-embed">
              <iframe
                className="youtube-vid"
                title="YouTube video player"
                src={YOUTUBE_EMBED}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      </section>

      <section className="hero-container no-border" style={{ position: 'relative' }}>
        <div className="container" style={{ position: 'relative', zIndex: 2 }}>
          <AboutCarousel />
          <img className="container mx-auto section-divider" src={dividerPNG} alt="divider image" />
        </div>
      </section>

      <LatestNews />

      <section className="sub-footer">
        <div className="container">
          <div className="cta-text-block">
            <img
              src={ctaTitleWEBP}
              alt="ready to begin your adventure?"
              className="w-50 mx-auto"
            />
            <p className="w-75 mx-auto">
              Join a community of passionate players and experience a
              <br />
              one-of-a-kind journey. Start your adventure today!
            </p>
            <Link to="/play" className="button cta">
              Join Now
            </Link>
          </div>
        </div>
      </section>

      <ReasonFooter />
    </div>
  );
}

function LatestNews() {
  return (
    <section className="hero-container no-border news-section" style={{ position: 'relative' }}>
      <div className="container" style={{ position: 'relative', zIndex: 2 }}>
        <h2 className="news-section-title">LATEST NEWS</h2>
        <div className="article-grid">
          {LATEST_NEWS.map((article) => (
            <article key={article.title} className="article-home">
              <div className="article-posted-time">
                <img src={calendarIconSVG} alt="calendar icon" />
                <span>{article.date}</span>
              </div>
              <div className="article-title">{article.title}</div>
              <div className="article-description">{article.description}</div>
              <div className="article-action">
                <a href="#" className="button small" onClick={(e) => e.preventDefault()}>
                  read full article
                </a>
              </div>
            </article>
          ))}
        </div>
        <div className="browse-news">
          <a href="#" className="button secondary" onClick={(e) => e.preventDefault()}>
            Browse all news <img src={browseArrowSVG} alt="browse arrow right" className="icon" />
          </a>
        </div>
      </div>
    </section>
  );
}

function AboutCarousel() {
  const [slideIndex, setSlideIndex] = useState(0);

  function moveSlide(delta) {
    setSlideIndex((prev) => {
      const next = prev + delta;
      if (next < 0) return CAROUSEL_IMAGES.length - 1;
      if (next >= CAROUSEL_IMAGES.length) return 0;
      return next;
    });
  }

  function goToSlide(index) {
    setSlideIndex(index);
  }

  return (
    <div className="grid-container">
      <div className="left-section">
        <h2 style={{ marginBottom: '20px' }}>About Reason</h2>
        <p>
          Treason is a one of a kind OSRS experience made by veterans who got tired of the same
          old grind and added a lot of unique things to make the game you know and love fun!
        </p>
        <div className="about-actions mx-auto">
          <div className="action-group">
            <Link to="/play" className="button small">
              Download Reason
            </Link>
          </div>
          <div className="action-group">
            <a href={SITE_DISCORD} className="button small secondary" target="_blank" rel="noreferrer">
              Join Discord
            </a>
          </div>
        </div>
      </div>

      <div className="right-section">
        <div className="carousel-container">
          <div className="carousel-slide">
            {CAROUSEL_IMAGES.map((image, index) => (
              <img
                key={image}
                src={image}
                alt={`Screenshot ${index + 1}`}
                className={index === slideIndex ? 'active' : ''}
              />
            ))}
          </div>
          <div className="carousel-controls">
            <button type="button" className="prev" onClick={() => moveSlide(-1)} aria-label="Previous slide">
              &#10094;
            </button>
            <button type="button" className="next" onClick={() => moveSlide(1)} aria-label="Next slide">
              &#10095;
            </button>
          </div>
          <div className="carousel-indicators">
            {CAROUSEL_IMAGES.map((image, index) => (
              <button
                key={image}
                type="button"
                className={`dot${index === slideIndex ? ' active' : ''}`}
                onClick={() => goToSlide(index)}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomePage;
